import './App.css';
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import ROUTES from "./routes";

import Home from "../components/landing/Home";
import MissingPage from '../components/landing/MissingPage';

export default function App() {

  return (
    <Routes>
      <Route path={ROUTES.homeRoute()} element={<Home/>} />
      <Route path={ROUTES.missingRoute()} element={<MissingPage/>} />
      <Route path="*" element={<Navigate to={ROUTES.missingRoute()} />} />
    </Routes>
  );
}
